import { ActionTypes } from "../constants";

const reduceSurveys = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.GET_MSF_SURVEY_LIST_SUCCESS:
            return action.data || [];

        case ActionTypes.UPDATE_MSF_SURVEY_SUCCESS:
            return [
                ...state.filter(({uuid}) => uuid !== action.payload.id),
                {
                    ...state.find(({uuid}) => uuid === action.payload.id),
                    ...action.payload.params
                }
            ];

        case ActionTypes.GET_MSF_SURVEY_SUCCESS:
            return !state ? [action.data] : [
                ...state.filter(({uuid}) => uuid !== action.data.uuid),
                action.data
            ];

        case ActionTypes.ADD_MSF_SURVEY_SUCCESS:
            return [...state, action.data];

        case ActionTypes.DELETE_MSF_SURVEY_SUCCESS:
            return !state ? [] : state.filter(({uuid}) => uuid !== action.payload.id);

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export const getSurvey = (surveys, surveyId) => !surveys ? [] : surveys.find(({uuid}) => uuid === surveyId);

export default reduceSurveys;
